import { render, staticRenderFns } from "./RequestDocumentDraft.vue?vue&type=template&id=1136f515&scoped=true"
import script from "./RequestDocumentDraft.vue?vue&type=script&lang=js"
export * from "./RequestDocumentDraft.vue?vue&type=script&lang=js"
import style0 from "./RequestDocumentDraft.vue?vue&type=style&index=0&id=1136f515&prod&lang=scss&scoped=true"
import style1 from "./RequestDocumentDraft.vue?vue&type=style&index=1&id=1136f515&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1136f515",
  null
  
)

export default component.exports